import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  targetId: Constants.RegisterHash,
  serviceId: null,
  attributeTypeId: null,
  values: {},
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
}

const actions = {
	show ({commit}, {serviceUuid, attributeTypeUuid, data}) {
    // 新規作成の場合「Constants.RegisterHash」
    // コピーの場合「NoticeId」が引き渡される
    commit('setTargetId', data.attributeGroupUuid)
    commit('setServiceId', serviceUuid)
    commit('setAttributeTypeId', attributeTypeUuid)

    // flag
    commit('setUpdated', false)

    // data
    commit('initModify', data)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setServiceId (state, id) {
    state.serviceId = id
  },
  setAttributeTypeId (state, id) {
    state.attributeTypeId = id
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  // initRegister (state) {
  //   Vue.set(state, 'values', {})
  // },
  initModify (state, data) {
    if (data?.hasOwnProperty("notifyToDevice")) {
      Vue.set(state, "values", data);
    } else {
      Vue.set(state, "values", data);
      Vue.set(state.values, "notifyToDevice", {
        deviceSerialNo: null,
        locationProfile: null
      });
    }
    Vue.set(state.values, 'inpCode', data.attributeGroupCode)
    Vue.set(state.values, 'inpMailAddress', data.attributeGroupMailAddress)
    Vue.set(
      state.values,
      "locationNickname",
      data?.hasOwnProperty("notifyToDevice")
        ? data.notifyToDevice.locationProfile
        : null
    );
    Vue.set(
      state.values,
      "inpDeviceSerial",
      data?.hasOwnProperty("notifyToDevice")
        ? data.notifyToDevice.deviceSerialNo
        : null
    );
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
